<template>
  <section class="emh-side-filters-category-filter-template">
    <header class="emh-side-filters-category-filter-template__header">
      <h4 v-if="title" class="emh-side-filters-category-filter-template__title">
        {{ title }}
      </h4>
      <testing-generic-wrapper storage-key="ClearSectionButton">
        <template #targetA>
          <button
            v-if="filterCounter > 0"
            class="emh-side-filters-category-filter-template__button wb-link wb-link--inline wb-link--small"
            @click="onClearCategory"
          >
            {{ $t('dcp.assortment.cars.filtersSearch.filters.resetAlt') }} ({{ filterCounter }})
          </button>
        </template>
      </testing-generic-wrapper>
    </header>
    <hr v-if="!hideDivider && title" class="emh-side-filters-category-filter-template__title-divider" />
    <div class="emh-side-filters-category-filter-template__content-wrapper">
      <slot />
    </div>
  </section>
</template>

<script lang="ts">
export default {
  name: 'EmhSideFiltersCategoryFilterTemplate',
};
</script>

<script lang="ts" setup>
import TestingGenericWrapper from '@dh-io-emh/shared/src/components/testingGenericWrapper/TestingGenericWrapper.vue';
import { inject } from 'vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  filterCounter: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['clear-category']);

const hideDivider = inject('hideDivider');

const onClearCategory = () => emit('clear-category');
</script>

<style lang="scss" scoped>
.emh-side-filters-category-filter-template {
  &__content-wrapper {
    @include wb-spacing('margin-bottom', 'm');
  }

  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
  }

  &__button {
    @include wb-spacing('margin-bottom', 'xs');
    border: none;
  }

  &__title {
    @include wb-type-heading-xs;
    @include wb-spacing('margin-bottom', 'xs');
    @include breakpoint-between(mq3, mq4) {
      @include wb-spacing('margin-bottom', 's');
    }
    color: var(--wb-grey-20);
  }

  &__title-divider {
    background-color: var(--wb-grey-85);
    height: 1px;
    border: 0;
    @include wb-spacing('margin-bottom', 'xs');
    @include breakpoint-between(mq3, mq4) {
      @include wb-spacing('margin-bottom', 's');
    }
  }
}
</style>
